import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { CButton } from '@app/components/Common';
import { COLORS } from '@app/constants';
import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Text, View } from '@/styles/reactnative';
import { Col, Input, message, Modal, Row, Upload, Button } from 'antd';
import styled from 'styled-components';
import { useMyProfile } from '../../../../hooks/user/myprofile';

import { media } from '@/styles/Qtheme.ts';
import { ThemeContext } from '@/theme/ThemeProvider';
import { VITE_APP_API_MEDIA_URL } from '@app/constants/APIKEYS.tsx';
import { useToken } from '@app/hooks';
import API from '@utils/api.ts';
import { MobileCalVW, useIsMobile } from '@utils/CalVW.tsx';
import DarkEmail from '../../assets/DarkEmail.svg?react';
import DarkHourglass from '../../assets/DarkHourglass.svg?react';
import Email from '../../assets/Email.svg?react';
import Hourglass from '../../assets/Hourglass.svg?react';
import { useDisableScroll } from '@utils/useDisableScroll.tsx';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useKYCStatus } from '@app/hooks/KYC/GetKYCStatus.tsx';
import { USER_LOG_TYPE, useUserLogger } from '@/app/hooks/userLogger';


const IdentifyBody = ({ level, last }) => {
  const { t } = useTranslation();
  const { mutateUserLog } = useUserLogger();
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';
  const { token } = useToken();

  const { data: myinfo } = useMyProfile();
  const { KYCStatus, KYCStatusMutate } = useKYCStatus();
  // const {UserKYCList} = useUserKYCList(1, 1000)
  // const {KYCStatus} = useKYCStatus()

  const [imageUrl, setImageUrl] = useState<any>();
  const [imageUrl2, setImageUrl2] = useState<any>();
  let verified = false;
  const mylevel = parseInt(myinfo?.level);
  const currentlevel = parseInt(level?.[0]?.level);
  const isMobile = useIsMobile();

  const [level2, setLevel2] = React.useState(false);
  const [level3, setLevel3] = React.useState(false);
  const [address, setAddress] = React.useState('');
  const [fullname, setFullname] = React.useState(myinfo?.fullname);
  const [bank1, setBank1] = React.useState('');
  const [bank2, setBank2] = React.useState('');

  // 휴대전화번호 인증 관련 상태
  const [phoneNumber, setPhoneNumber] = React.useState('');
  const [countryCode, setCountryCode] = React.useState('82');
  const [verifyId, setVerifyId] = React.useState(false);
  const [verifyCode, setVerifyCode] = React.useState('');
  const [checkVerify, setCheckVerify] = React.useState(false);

  // myinfo.phone이 있을 경우 휴대전화번호 고정 설정
  useEffect(() => {
    if (myinfo?.phone && myinfo.phone !== null) {
      setPhoneNumber(myinfo.phone);
    }
  }, [myinfo]);

  const cancelModal2 = () => {
    setLevel2(false);
    setLevel3(false);
    setImageUrl(null);
    setImageUrl2(null);
    setAddress('');
    // setAddressProof('');
    // 휴대전화번호 인증 상태 초기화
    // myinfo.phone이 있는 경우에는 휴대폰번호를 초기화하지 않음
    if (!myinfo?.phone || myinfo.phone === null) {
      setPhoneNumber('');
    }
    setCountryCode(countryCode);
    setVerifyId(false);
    setVerifyCode('');
    setCheckVerify(false);
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error(t('You can only upload JPG/PNG file!'));
    }
    const isLt10M = file.size / 1024 / 1024 <= 10;
    if (!isLt10M) {
      message.error(t('Image must be 10MB or smaller!'));
    }
    return isJpgOrPng && isLt10M;
  };

  // console.log(myinfo);
  if (currentlevel === 1) {
    if (mylevel >= 1 || mylevel === -1) {
      verified = true;
    }
  } else if (currentlevel === 2) {
    if (mylevel >= 3) {
      verified = true;
    }
  } else if (currentlevel === 3) {
    if (mylevel >= 4) {
      verified = true;
    }
  }

  // KYC 상태가 2(승인됨)인 경우에도 verified를 true로 설정
  if (KYCStatus?.status === 2) {
    verified = true;
  }

  // 이하 이미지 업로드 기능
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const handleUploadChange = async (info) => {
    if (loading) return;
    setLoading(true);

    try {
      const response = await API.post('/upload/presigned-url', token, {
        usage: 'kyc-license',
        fileExtension: info?.file?.type === 'image/jpeg' ? 'jpg' : 'png',
      });

      if (response.success) {
        const fileUrl = response.result.url;
        const resPatchUrl = await fetch(fileUrl, {
          method: 'PUT',
          body: info?.file?.originFileObj,
          headers: { 'Content-Type': info?.file?.type },
        });

        if (resPatchUrl.ok) {
          const imageUrl = `${VITE_APP_API_MEDIA_URL}/${response.result.key}`;
          const resCheck = await fetch(imageUrl);
          if (resCheck.ok) {
            setImageUrl(response.result.key);
            message.success('Image upload successfully');
          } else {
            message.error(
              'Uploaded image is not yet available. Please try again later.'
            );
          }
        }
      }
    } catch (error) {
      console.error('Upload failed', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUploadChange2 = async (info) => {
    if (loading2) return;
    setLoading2(true);

    try {
      const response = await API.post('/upload/presigned-url', token, {
        usage: 'selfie',
        fileExtension: info?.file?.type === 'image/jpeg' ? 'jpg' : 'png',
      });

      if (response.success) {
        const fileUrl = response.result.url;
        const resPatchUrl = await fetch(fileUrl, {
          method: 'PUT',
          body: info?.file?.originFileObj,
          headers: { 'Content-Type': info?.file?.type },
        });

        if (resPatchUrl.ok) {
          const imageUrl = `${VITE_APP_API_MEDIA_URL}/${response.result.key}`;
          const resCheck = await fetch(imageUrl);
          if (resCheck.ok) {
            setImageUrl2(response.result.key);
            message.success('Image upload successfully');
          } else {
            message.error(
              'Uploaded image is not yet available. Please try again later.'
            );
          }
        }
      }
    } catch (error) {
      console.error('Upload failed', error);
    } finally {
      setLoading2(false);
    }
  };

  const handleUploadChange3 = async (info) => {
    if (loading2) return;
    setLoading2(true);

    try {
      const response = await API.post('/upload/presigned-url', token, {
        usage: 'address-proof',
        fileExtension: info?.file?.type === 'image/jpeg' ? 'jpg' : 'png',
      });

      if (response.success) {
        const fileUrl = response.result.url;
        const resPatchUrl = await fetch(fileUrl, {
          method: 'PUT',
          body: info?.file?.originFileObj,
          headers: { 'Content-Type': info?.file?.type },
        });

        if (resPatchUrl.ok) {
          const imageUrl = `${VITE_APP_API_MEDIA_URL}/${response.result.key}`;
          const resCheck = await fetch(imageUrl);
          if (resCheck.ok) {
            setImageUrl2(response.result.key);
            message.success('Image upload successfully');
          } else {
            message.error(
              'Uploaded image is not yet available. Please try again later.'
            );
          }
        }
      }
    } catch (error) {
      console.error('Upload failed', error);
    } finally {
      setLoading2(false);
    }
  };

  // 중복 체크 함수 (처리중/검토중인 KYC만 중복으로 간주)
  const checkDuplicateKYC = async () => {
    try {
      // KYC 상태가 거절(3)인 경우는 재신청 허용
      if (KYCStatus?.status === 3) {
        return false;
      }

      // 처리중(0) 또는 검토중(1)인 경우만 중복으로 간주
      if (KYCStatus?.status === 0 || KYCStatus?.status === 1) {
        alert('KYC가 이미 신청되어 있습니다.');
        return true;
      }

      return false;
    } catch (e) {
      console.error('중복 체크 실패', e);
      return false;
    }
  };

  const handleOk = async (process) => {
    // api 연동

    // KYC 상태 확인하여 중복 신청 방지 (거절된 경우는 재신청 가능)
    if (KYCStatus?.status === 0 || KYCStatus?.status === 1) {
      message.warning(
        KYCStatus?.status === 0 ? t('KYC application is being processed') :
          t('KYC application is under review')
      );
      return;
    }

    if (process === 2) {
      if (!checkVerify) {
        message.error(t('Phone number verification is required'));
        return;
      }

      if (!fullname) {
        message.error(t('Please enter your Full Name.'));
        return;
      }

      if (!imageUrl) {
        message.error(t('Please add your ID Card.'));
        return;
      }

      if (!imageUrl2) {
        message.error(t('Please add your Selfie.'));
        return;
      }

      if (!bank1) {
        message.error(t('Please enter your Bank Name.'));
        return;
      }

      if (!bank2) {
        message.error(t('Please enter your Account Number.'));
        return;
      }

      // 계좌번호 형식 검증 (숫자와 하이픈만 허용)
      const accountNumberPattern = /^[0-9-]+$/;
      if (!accountNumberPattern.test(bank2)) {
        message.error(t('Account number can only contain numbers and hyphens.'));
        return;
      }

      // 계좌번호 최소 길이 검증
      if (bank2.replace(/-/g, '').length < 8) {
        message.error(t('Account number must be at least 8 digits.'));
        return;
      }
    } else {
      if (!address) {
        message.error(t('Please enter your Address.'));
        return;
      }

      if (!imageUrl) {
        message.error(t('Please add your Address Proof.'));
        return;
      }
    }

    const payload =
      process === 2
        ? {
          process,
          userData: {
            name: fullname,
            licenseImage: imageUrl,
            selfie: imageUrl2,
            accountHolder: fullname,
            bankName: bank1,
            accountNumber: bank2,
            phoneNumber: myinfo?.phone && myinfo.phone !== null
              ? (myinfo.phone.startsWith('+') ? myinfo.phone : '+' + myinfo.phone)
              : '+' + countryCode + phoneNumber,
          },
        }
        : {
          process,
          userData: {
            address,
            addressProof: imageUrl,
          },
        };

    // 해당 토큰의 user_id 를 통해 users_kyc 테이블에서 데이터 중복 되는지 조회
    // 중복된다면 알람을 띄우고 return

    if (await checkDuplicateKYC()) {
      return;
    }

    API.post('/kyc', token, payload)
      .then((res) => {
        // console.log(res);
        if (res?.success) {
          mutateUserLog({
            log : USER_LOG_TYPE.KYC_REQUEST,
            data : payload,
          })
          message.success('Register Success');
          // KYC 상태를 새로고침하여 UI 업데이트
          KYCStatusMutate();
          cancelModal2();
        } else {
          message.error(res?.error?.message || 'Register Failed');
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const uploadButton = (
    <UploadButton type="button">
      {loading ? <LoadingOutlined />:<PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("upload")}

      </div>
    </UploadButton>
  );

  const uploadButton2 = (
    <UploadButton type="button">
      {loading2 ? <LoadingOutlined />:<PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("upload")}

      </div>
    </UploadButton>
  );


  const handleTouchMove = (e) => {
    e.stopPropagation();
  };


  useDisableScroll(level2);
  useDisableScroll(level3);

  // 휴대전화번호 인증 요청 함수
  const handleCheckPhone = async () => {
    // myinfo.phone이 있을 경우 고정 번호 사용, 없을 경우 입력된 번호 사용
    const phoneToUse = myinfo?.phone && myinfo.phone !== null ? myinfo.phone : countryCode + phoneNumber;

    if (!phoneToUse) {
      message.error(t('Please enter your phone number'));
      return;
    }

    try {
      const res = await API.send('POST', `/verification/send`, token, {
        type: 'sms',
        contact: phoneToUse.startsWith('+') ? phoneToUse : '+' + phoneToUse,
      });

      if (res?.success) {
        setVerifyId(true);
        message.success(t('Verification code sent'));
      } else {
        // 403 에러인 경우 차단된 휴대폰번호 메시지 표시
        if (res?.status === 403) {
          message.error(t('phoneNumberBlocked'));
        } else {
          message.error(res?.result?.message || t('Failed to send verification code'));
        }
      }
    } catch (e: any) {
      console.log(e, 'ERROR VERIFY SYSTEM');
      // 403 에러인 경우 차단된 휴대폰번호 메시지 표시
      if (e?.response?.status === 403) {
        message.error(t('phoneNumberBlocked'));
      } else {
        message.error(t('Failed to send verification code'));
      }
    }
  };

  // 인증번호 확인 함수
  const handleVerifiedCode = async () => {
    if (!verifyCode) {
      message.error(t('Please enter verification code'));
      return;
    }

    // myinfo.phone이 있을 경우 고정 번호 사용, 없을 경우 입력된 번호 사용
    const phoneToUse = myinfo?.phone && myinfo.phone !== null ? myinfo.phone : countryCode + phoneNumber;

    try {
      // 인증 성공 후 사용자 정보 업데이트
      const updateRes = await API.send('POST', `/verification/user/update`, token, {
        type: 'sms',
        contact: phoneToUse.startsWith('+') ? phoneToUse : '+' + phoneToUse,
        code: verifyCode,
      });

      if (updateRes?.success) {
        setCheckVerify(true);
        message.success(t('Phone number verified and updated successfully'));
      } else {
        setCheckVerify(false);
        message.error(updateRes?.result?.message || t('Phone number verification failed'));
      }
    } catch (updateError) {
      console.log(updateError, 'ERROR UPDATE USER INFO');
      setCheckVerify(false);
      message.error(t('Failed to verify code'));
    }
  };

  return (
    <View
      style={{
        height: '90%',
        width: '100%',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: 15,
      }}
    >
      <View style={{ alignItems: 'flex-start' }}>
        <View
          style={{
            paddingLeft: 10,
          }}
        >
          <ColorText style={{ color: '#F87943' }}>
            {t('requirements')}
          </ColorText>
        </View>
        <View style={{ flexDirection: 'row', marginTop: 10 }}>
          {level?.map((item: any, index: any) => (
            <IconTextWrap key={index.toString()}>
              <IconWrap>
                <IconSVG as={theme === 'light' ? DarkEmail : Email} />
              </IconWrap>
              <NormalText style={{ marginLeft: 5 }}>
                {t(item?.title)}
              </NormalText>
            </IconTextWrap>
          ))}
        </View>

        <IconTextWrap style={{ marginTop: 12 }}>
          <IconWrap>
            <IconSVG as={theme === 'light' ? DarkHourglass : Hourglass} />
          </IconWrap>
          <Text size={14} style={{ marginLeft: 6 }}>
            {t('reviewDuration')}
          </Text>
        </IconTextWrap>

        {currentlevel === 2 && (
          <IconTextWrap style={{ marginTop: 12 }}>
            <IconWrap>
              <IconSVG as={theme === 'light' ? DarkEmail : Email} />
            </IconWrap>
            <NormalText style={{ marginLeft: 5 }}>
              {t('EnterAccountInfo')}
            </NormalText>
          </IconTextWrap>
        )}
      </View>
      {!verified ? (
        <CButton
          title={
            // KYC 상태에 따른 버튼 텍스트 변경
            KYCStatus?.status === 0 ? t('Processing') :
              KYCStatus?.status === 1 ? t('Under Review') :
                t('verifyNow')
          }
          onClick={() => {
            // 처리중이거나 검토중인 경우만 클릭 방지 (거절된 경우는 재신청 가능)
            if (KYCStatus?.status === 0 || KYCStatus?.status === 1) {
              message.warning(
                KYCStatus?.status === 0 ? t('KYC application is being processed') :
                  t('KYC application is under review')
              );
              return;
            }

            if (level?.[0]?.level === 2 && mylevel === 1) {
              setLevel2(true);
            } else if (level?.[0]?.level === 3 && mylevel === 3) {
              setLevel3(true);
            } else {
              message.error('You are not eligible for this level');
            }
          }}
          style={{
            width: '100%',
            height: 40,
            background: COLORS.primary,
            color: COLORS.white,
            marginTop: isMobile ? 20 : 0,
            opacity: (KYCStatus?.status === 0 || KYCStatus?.status === 1) ? 0.6 : 1,
            cursor: (KYCStatus?.status === 0 || KYCStatus?.status === 1) ? 'not-allowed' : 'pointer',
          }}
        />
      ) : null}

      <Modal
        open={level2}
        onCancel={() => cancelModal2()}
        okText={t("request")}
        cancelText={t("cancel")}
        onOk={() => {
          handleOk(2);
        }}
      >
        <div onTouchMove={handleTouchMove}>
          {t("kycRequest")}

          <Row align={'middle'} style={{ marginTop: 20, gap: 50 }}>
            <Col>{t("idCard")}</Col>

            <Upload
              name="avatar"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
              beforeUpload={beforeUpload}
              onChange={handleUploadChange}
            >
              {imageUrl ? (
                <div
                  style={{
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%',
                    borderRadius: 9999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    crossOrigin="anonymous"
                    src={`${VITE_APP_API_MEDIA_URL}/${imageUrl}`}
                    alt="avatar"
                    style={{
                      width: '100%',
                    }}
                  />
                </div>
              ) : (
                uploadButton
              )}
            </Upload>
          </Row>
          <Row align={'middle'} style={{ marginTop: 20, gap: 64 }}>
            <Col>{t("selfie")}</Col>

            <Upload
              name="avatar"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
              beforeUpload={beforeUpload}
              onChange={handleUploadChange2}
            >
              {imageUrl2 ? (
                <div
                  style={{
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%',
                    borderRadius: 9999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    crossOrigin="anonymous"
                    src={`${VITE_APP_API_MEDIA_URL}/${imageUrl2}`}
                    alt="avatar"
                    style={{
                      width: '100%',
                    }}
                  />
                </div>
              ) : (
                uploadButton2
              )}
            </Upload>
          </Row>

          {/* 휴대전화번호 인증 섹션 */}
          <Row align={'middle'} style={{ marginTop: 20 }}>
            <Col span={6}>{t('phoneNumber')}</Col>
            <Col span={14}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  backgroundColor: theme === 'light' ? '#F6EDEA' : '#191A19',
                  padding: '0 12px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  color: theme === 'light' ? '#000' : '#fff',
                  borderRight: 'none',
                  borderRadius: '5px 0 0 5px',
                  fontSize: '14px',
                  width: '55px',
                }}>
                  +{countryCode}
                </div>
                <PhoneInput
                  disableCountryCode={true}
                  disableDropdown={false}
                  // countryCodeEditable={false}
                  autoFormat={false}
                  dropdownClass="react-tel-input"
                  country={'kr'}
                  // value={phoneNumber}
                  onChange={(phone, countryData) => {
                    if ('dialCode' in countryData) {
                      setCountryCode(countryData.dialCode);
                    }
                    // if (!myinfo?.phone || myinfo.phone === null) {
                    //   // setPhoneNumber(phone);
                    //   if ('dialCode' in countryData) {
                    //     setCountryCode(countryData.dialCode);
                    //   }
                    // }
                  }}
                  // placeholder={t('phoneNumber')}
                  disabled={myinfo?.phone && myinfo.phone !== null}
                  containerStyle={{
                    width: 50,
                  }}
                  inputStyle={{
                    backgroundColor: theme === 'light' ? '#F6EDEA' : '#191A19',
                    color: theme === 'light' ? '#000' : '#fff',
                    border: 'none',
                    width: '100%',
                    height: '32px',
                    borderRadius: 0,
                    cursor: myinfo?.phone && myinfo.phone !== null ? 'not-allowed' : 'text',
                    opacity: myinfo?.phone && myinfo.phone !== null ? 0.6 : 1,
                  }}
                  buttonStyle={{
                    backgroundColor: theme === 'light' ? '#F6EDEA' : '#191A19',
                    color: theme === 'light' ? '#000' : '#fff',
                    border: 'none',
                    cursor: myinfo?.phone && myinfo.phone !== null ? 'not-allowed' : 'pointer',
                  }}
                  dropdownStyle={{
                    backgroundColor: theme === 'light' ? '#F6EDEA' : '#191A19',
                    color: theme === 'light' ? '#000' : '#fff',
                    border: 'none',
                    top: 40,
                  }}
                />
                <Input
                  type={'number'}
                  value={phoneNumber}
                  placeholder={t('phoneNumber')}
                  style={{
                    backgroundColor: theme === 'light' ? '#F6EDEA' : '#191A19',
                    color: theme === 'light' ? '#000' : '#fff',
                    border: 'none',
                    width: '100%',
                    height: '32px',
                    paddingLeft: 0,
                    outline: 'none',
                    boxShadow: 'none',
                    borderBottomLeftRadius: 0,
                    borderTopLeftRadius: 0
                  }}
                  onChange={(e) => {
                    // myinfo.phone이 있을 경우 번호 변경 불가
                    if (!myinfo?.phone || myinfo.phone === null) {
                      setPhoneNumber(e.target.value);
                    }
                  }}
                />
              </div>
            </Col>
            <Col span={4}>
              <Button
                size="small"
                style={{ marginLeft: 8, height: 32 }}
                onClick={handleCheckPhone}
                disabled={false}
              >
                {verifyId ? t('resend') : t('request')}
              </Button>
            </Col>
          </Row>

          {verifyId && (
            <Row align={'middle'} style={{ marginTop: 10 }}>
              <Col span={6}>{t('verificationCode')}</Col>
              <Col span={12}>
                <Input
                  disabled={checkVerify}
                  value={verifyCode}
                  placeholder={t('verificationCode')}
                  maxLength={6}
                  onChange={(e) => setVerifyCode(e.target.value)}
                  style={{
                    height: 32, outline: 'none',
                    boxShadow: 'none', border: 'none'
                  }}
                />
              </Col>
              <Col span={6}>
                <Button
                  size="small"
                  style={{ marginLeft: 8, height: 32 }}
                  onClick={handleVerifiedCode}
                  disabled={checkVerify}
                  type={checkVerify ? 'default' : 'primary'}
                >
                  {checkVerify ? '인증완료' : '인증확인'}
                </Button>
              </Col>
            </Row>
          )}

          <Row align={'middle'} style={{ marginTop: 20 }}>
            <Col span={6}>{t("accountHolder")}</Col>
            <Col span={18}>
              <Input
                // value={fullname}
                style={{
                  height: 32, outline: 'none',
                  boxShadow: 'none', border: 'none'
                }}
                placeholder={t("accountHolder")}
                maxLength={20}
                onChange={(e) => {
                  setFullname(e.target.value);
                }}
              />
            </Col>
          </Row>

          <Row align={'middle'} style={{ marginTop: 20 }}>
            <Col span={6}>{t("bankName")}</Col>
            <Col span={18}>
              <Input
                style={{
                  height: 32, outline: 'none',
                  boxShadow: 'none', border: 'none'
                }}
                value={bank1}
                placeholder={t("bankName")}
                maxLength={20}
                onChange={(e) => {
                  // 특수문자만 제거 (한글 입력 문제 방지)
                  const value = e.target.value.replace(/[!@#$%^&*()_+=\[\]{}|\\:";'<>?,./`~]/g, '');
                  setBank1(value);
                }}
              />
            </Col>
          </Row>

          <Row align={'middle'} style={{ marginTop: 20 }}>
            <Col span={6}>{t("accountNumber")}</Col>
            <Col span={18}>
              <Input
                style={{
                  height: 32, outline: 'none',
                  boxShadow: 'none', border: 'none'
                }}
                value={bank2}
                placeholder={t("accountNumber")}
                maxLength={30}
                onChange={(e) => {
                  // 숫자와 하이픈만 허용
                  const value = e.target.value.replace(/[^0-9-]/g, '');
                  setBank2(value);
                }}
              />
            </Col>
          </Row>

        </div>
      </Modal>

      <Modal
        open={level3}
        onCancel={() => cancelModal2()}
        okText={t("request")}
        onOk={() => {
          handleOk(3);
        }}
      >
        <div onTouchMove={handleTouchMove}>

          {t("kycRequest")}
          <Row align={'middle'} style={{ marginTop: 10 }}>
            <Col>{t("address")}</Col>
            <Col style={{ marginLeft: 10 }}>
              <Input
                value={address}
                placeholder={t("address")}
                maxLength={15}
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row align={'middle'} style={{ marginTop: 20, gap: 50 }}>
            <Col>{t("addressProof")}</Col>

            <Upload
              name="avatar"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
              beforeUpload={beforeUpload}
              onChange={handleUploadChange3}
            >
              {imageUrl ? (
                <div
                  style={{
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%',
                    borderRadius: 9999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    crossOrigin="anonymous"
                    src={`${VITE_APP_API_MEDIA_URL}/${imageUrl2}`}
                    alt="avatar"
                    style={{
                      width: '100%',
                    }}
                  />
                </div>
              ) : (
                uploadButton
              )}
            </Upload>

            {/* <Col style={{ marginLeft: 10 }}>
            <Input
              value={bank1}
              placeholder="은행명"
              maxLength={10}
              width={50}
              style={{ marginRight: 10, width: 70 }}
              onChange={(e) => {
                setBank1(e.target.value);
              }}
            />
          </Col>
          <Col>
            <Input
              value={bank2}
              placeholder="계좌번호"
              onChange={(e) => {
                setBank2(e.target.value);
              }}
            />
          </Col> */}
          </Row>
        </div>
      </Modal>
    </View>
  );
};

export default IdentifyBody;

const IconTextWrap = styled.div`
  display: flex;
  gap: 6px;
  padding-left: 10px;
`;

const IconWrap = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 9999px;
  background-color: ${({ theme }) => theme.p2pBorder};
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${media.mobile} {
    width: ${MobileCalVW(28)};
    height: ${MobileCalVW(28)};
  }
`;

const IconSVG = styled.svg`
  width: 15.27px;
  height: 15.27px;

  @media ${media.mobile} {
    width: ${MobileCalVW(15.27)};
    height: ${MobileCalVW(15.27)};
  }
`;

const ColorText = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;

  @media ${media.mobile} {
    font-size: ${MobileCalVW(13)};
    margin-bottom: ${MobileCalVW(12)};
  }
`;

const NormalText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.text};

  @media ${media.mobile} {
    font-size: ${MobileCalVW(14)};
  }
`;

const UploadButton = styled.button`
  border: 0;
  background: none;
  color: ${({ theme }) => theme.text};
`;
